import BaseService from './base.service'

/**
 * ユースケース選択サービス。
 */
export default class UseCaseSelectionService extends BaseService {
  /**
   * ユースケース選択サービスインスタンスを取得します。
   *
   * @returns {UseCaseSelectionService} ユースケース選択サービスインスタンス
   */
  static getInstance() {
    if (!this.useCaseSelectionService) {
      this.useCaseSelectionService = new UseCaseSelectionService()
    }
    return this.useCaseSelectionService
  }

  /**
   * 現在のユーザーのユースケースの選択を取得します。
   *
   * @returns 現在のユーザーのユースケース選択データ
   */
  async getUseCaseSelections() {
    const useCaseSelectionResponse = await this.http.get('/func/use-case-selection').catch(err => {
      console.log(err)
      throw err
    })
    if (!useCaseSelectionResponse) {
      return null
    }
    return useCaseSelectionResponse.data.useCaseSelections
  }
}



// WEBPACK FOOTER //
// ./src/_services/use-case-selection.service.js